var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-2512"},[_vm._v("\n  2512\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }